import { useCallback } from "react";
import { useLocation, useNavigate, Navigate, NavigateProps } from "react-router-dom";

export const useLocalNavigate = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const handleNavigate = useCallback(
    (pathname: string) => {
      navigate({
        pathname,
        search,
      });
    },
    [navigate, search]
  );

  return handleNavigate;
};

export const LocalNavigate = ({ to, ...props }: NavigateProps) => {
  const { search } = useLocation();

  return (
    <Navigate
      to={{
        pathname: String(to),
        search,
      }}
      {...props}
    />
  );
};
